import { FC, useState } from 'react';
import { Box } from '@mui/material';
import { PieChart, Pie, Legend, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from 'recharts';
import styles from 'features/statistics/ui/MedicalControlPanel.module.css';
import { StyledBottomNavigation, StyledBottomNavigationAction } from 'features/insurance-contracts/ui/StyledComponents';

const data01 = [
    { name: 'Москва', value: 97, fill: '#0054E6' },
    { name: 'Московская область', value: 1.6, fill: '#4025C0' },
    { name: 'Донецкая Народная Респ', value: 1.4, fill: '#AAA0FF' },
];
// Данные для бар-диаграммы
const barData = [
    { name: 'Клиника МЕДСИ на Ленинском проспекте (КПП)', value: 21.90 },
    { name: 'КДЦ МЕДСИ на Белорусской', value: 15.48 },
    { name: 'КДЦ "Арбатский" ФГБН НМХЦ ИМ. Н.И.ПИРОГОВА', value: 15.15 },
    { name: 'МЦ ПОЛИКЛИНИКА.РУ', value: 7 }
];
const RADIAN = Math.PI / 180;

interface PieLabelProps {
    cx: number;
    cy: number;
    midAngle?: number;
    innerRadius?: number;
    outerRadius?: number;
    percent?: number;
    index?: number;
    payload?: any;
}

const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle = 0,
    outerRadius = 0,
    percent = 0,
    index = 0,
    payload = []
}: PieLabelProps) => {
    if (payload.value < 5) {
        return null;
    }

    const radius = outerRadius + 20;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const color = payload[index]?.fill || '#444444';

    return (
        <>
            <path
                d={`M${cx + (outerRadius + 10) * Math.cos(-midAngle * RADIAN)},${cy + (outerRadius + 10) * Math.sin(-midAngle * RADIAN)} L${x},${y}`}
                stroke={color}
                fill="none"
            />
            <text
                x={x}
                y={y}
                fill="#4e4e4e"
                textAnchor={x > cx ? 'start' : 'end'}
                dominantBaseline="central"
                style={{ fontSize: '11px' }}
            >
                {`${Math.round(percent * 100)}%`}
            </text>
        </>
    );
};

export const ClinicPanel: FC = () => {
    const [value, setValue] = useState(true);

    return (
        <Box>

            <Box className={styles.btnBox}>
                <StyledBottomNavigation
                    width="600px"
                    value={value ? 0 : 1}
                    onChange={(_, newValue) => {
                        setValue(newValue === 0);
                    }}
                    showLabels
                >
                    <StyledBottomNavigationAction
                        custommaxwidth="300px"
                        data-isactive={value}
                        data-isleft={true}
                        data-isright={false}
                        label="Обращения в разрезе клиник"
                    />
                    <StyledBottomNavigationAction
                        custommaxwidth="300px"
                        data-isactive={!value}
                        data-isleft={false}
                        data-isright={true}
                        label="В разрезе регионов обслуживания"
                    />
                </StyledBottomNavigation>
            </Box>

            {value ? (
                <Box className={styles.barChartContainer}>
                    <Box className={styles.barChartBox}>
                        {/* <p className={styles.titleBarChart}>Специальность</p> */}
                        <BarChart
                            layout="vertical"
                            width={700}
                            height={350}
                            data={barData}
                            margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
                        >
                            <CartesianGrid strokeDasharray="2 3" />
                            <XAxis type="number" />
                            <YAxis
                                dataKey="name"
                                type="category"
                                tick={{ fontSize: 12 }}
                                width={150}
                                minTickGap={0}
                            />
                            <Tooltip
                                formatter={(value, name, props) => [
                                    `${value} %`,
                                    "Значение"
                                ]}
                            />
                            <Bar dataKey="value" fill="#0054E6" isAnimationActive={true} />
                        </BarChart>
                    </Box>

                </Box>

            ) : (
                <Box className={styles.chartsContainer}>
                    <Box className={styles.chartWrapper}>
                        <PieChart width={450} height={250}>
                            <Pie
                                data={data01}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                label={renderCustomizedLabel}
                                outerRadius={90}
                                dataKey="value"
                                innerRadius={50}
                                startAngle={90}
                                endAngle={-270}
                                isAnimationActive={true}
                            />
                            <Legend
                                layout="vertical"
                                align="right"
                                verticalAlign="middle"
                                wrapperStyle={{ fontSize: '12px' }}
                                content={(props) => {
                                    const { payload } = props;
                                    return (
                                        <>
                                            {/* <p style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>Входящий канал связи</p> */}
                                            <ul style={{ listStyle: 'none', margin: 0, padding: 0, marginLeft: '20px' }}>
                                                {payload?.map((entry, index) => (
                                                    <li key={`item-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                                        <div
                                                            style={{
                                                                width: '12px',
                                                                height: '12px',
                                                                borderRadius: '50%',
                                                                backgroundColor: entry.color,
                                                                marginRight: '8px'
                                                            }}
                                                        />
                                                        <span style={{ fontSize: '12px' }}>{entry.value}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    );
                                }}
                            />
                        </PieChart>
                    </Box>

                </Box>
            )}

        </Box>
    );
};

export default ClinicPanel;